import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SupportService } from '../services/support.service';
import { NotifyAlertService } from '../services/notify-alert.service';

import { country } from '../model';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'monorepo-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  providers: [MessageService],
})
export class SupportComponent implements OnInit, OnDestroy {
  readonly subs = new SubSink();

  @Input()
  buttonColor = 'violet';

  country: any[];
  userSupportForm: FormGroup;
  priority: string[] = ['Low', 'Mid', 'High', 'Critical'];
  categories: string[] = ['Billing', 'General'];
  selectedCategory: string;
  selectedPriority: string;
  countryCode: string;

  constructor(
    private supportService: SupportService,
    private notifyAlertService: NotifyAlertService
  ) {}

  ngOnInit(): void {
    this.country = country;
    this.createUserSupportForm();
    this.getUserDetails();
  }

  public getUserDetails(): void {
    this.subs.sink = this.supportService.user.subscribe({
      next: (user: any): void => {
        if (user) {
          this.userSupportForm.patchValue({
            name: user.displayName,
            email: user.email,
          });
        }
      },
    });
  }

  public createUserSupportForm(): void {
    this.userSupportForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      category: new FormControl(''),
      priority: new FormControl(''),
      subject: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
    });
  }

  public userSupportData(): void {
    this.subs.sink = this.supportService
      .addSupportUser(this.userSupportForm.value)
      .subscribe({
        next: (): void => {
          this.notifyAlertService.success(
            'your response submitted successfully'
          );
          this.userSupportForm.reset();
          this.selectedCategory = '';
          this.selectedPriority = '';
        },
      });
  }

  public selectedCategoryOption(category: any): void {
    this.selectedCategory = category;
    this.userSupportForm.get('category').setValue(category);
  }

  public selectedPriorityOption(priority: any): void {
    this.selectedPriority = priority;
    this.userSupportForm.get('priority').setValue(priority);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public onCountrySearchByName(searchKeyword: any): void {
    let searchWord = '';
    searchWord = searchKeyword.target.value;
    if (searchWord === '') {
      this.country = country;
    } else {
      this.country = country.filter((countryElement: any) =>
        countryElement.name
          .toLowerCase()
          .includes(searchWord.toLocaleLowerCase())
      );
    }
  }
}
